import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import Header from "./header"
import Footer from "./footer";

const Layout = ({ children, feature }) => {
    const { placeholderImage, site, backgroundImage, featureImage } = useStaticQuery(
        graphql`
      query {
        placeholderImage: file(relativePath: { eq: "middle-bg.png" }) {
          childImageSharp {
            gatsbyImageData(
              placeholder: BLURRED
              formats: [AUTO, WEBP, AVIF]
            )
          }
        },
        backgroundImage: file(relativePath: { eq: "middle-content-bg.png" }) {
          childImageSharp {
            gatsbyImageData(
              placeholder: BLURRED
              formats: [AUTO, WEBP, AVIF]
            )
          }
        },
        featureImage: file(relativePath: { eq: "feature-bg.png" }) {
          childImageSharp {
            gatsbyImageData(
              placeholder: BLURRED
              formats: [AUTO, WEBP, AVIF]
            )
          }
        },
        site {
          siteMetadata {
            title
          }
        }
      }
    `
    )

    const image = getImage(placeholderImage)
    const middleImage = getImage(backgroundImage)
    const featureBgImage = getImage(featureImage)

    return (
        <>
            <Header siteTitle={site.siteMetadata.title} />
            <main>
                {/* Main background */}
                <div
                    style={{
                        position: "relative",
                        backgroundSize: "auto",
                        backgroundPosition: "0 0",
                        backgroundRepeat: "repeat",
                    }}
                >
                    {/* Main background wrapper */}
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            zIndex: 0,
                            pointerEvents: "none",
                        }}
                    >
                        <GatsbyImage
                            image={image}
                            alt=""
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                            }}
                            objectFit="fill"
                        />
                    </div>

                    {/* Feature section */}
                    <div
                        style={{
                            position: "relative",
                            backgroundSize: "auto",
                            backgroundPosition: "0 100%",
                            backgroundRepeat: "repeat-x",
                            zIndex: 1,
                        }}
                    >
                        {/* Feature background wrapper */}
                        <div
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                zIndex: 0,
                                pointerEvents: "none",
                            }}
                        >
                            <GatsbyImage
                                image={featureBgImage}
                                alt=""
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                }}
                                objectFit="fill"
                            />
                        </div>

                        {/* Feature content */}
                        <div className="container mx-auto" style={{ position: "relative", zIndex: 1 }}>
                            {feature}
                        </div>
                    </div>

                    {/* Main content section */}
                    <div className="container mx-auto pb-10" style={{ position: "relative", zIndex: 1 }}>
                        {/* Content background wrapper */}
                        <div
                            style={{
                                position: "relative",
                                backgroundSize: "auto",
                                backgroundPosition: "0 0",
                                backgroundRepeat: "repeat-x",
                            }}
                        >
                            {/* Content background image */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    zIndex: 0,
                                    pointerEvents: "none",
                                }}
                            >
                                <GatsbyImage
                                    image={middleImage}
                                    alt=""
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                    }}
                                    objectFit="fill"
                                />
                            </div>

                            {/* Main content */}
                            <div style={{ position: "relative", zIndex: 1 }}>
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            </main>
             <Footer />
        </>
    )
}

export default Layout